import { createGlobalStyle } from 'styled-components';
import { colors } from './constant.js';

const GlobalStyle = createGlobalStyle`
    body {
        transition: background-color 1s;
        background-color: ${ colors.body };
    }
    .navbar {

    }
`

export default GlobalStyle;